import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=0397c496&scoped=true&"
import script from "./CustomerOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerOrders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&id=0397c496&lang=scss&scoped=true&"
import style1 from "./CustomerOrders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397c496",
  null
  
)

export default component.exports